import { render, staticRenderFns } from "./AssetDisposal.vue?vue&type=template&id=73cf504a&scoped=true"
import script from "./AssetDisposal.vue?vue&type=script&lang=js"
export * from "./AssetDisposal.vue?vue&type=script&lang=js"
import style0 from "./AssetDisposal.vue?vue&type=style&index=0&id=73cf504a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cf504a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73cf504a')) {
      api.createRecord('73cf504a', component.options)
    } else {
      api.reload('73cf504a', component.options)
    }
    module.hot.accept("./AssetDisposal.vue?vue&type=template&id=73cf504a&scoped=true", function () {
      api.rerender('73cf504a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Asset/AssetDisposal/AssetDisposal.vue"
export default component.exports